import React, {Component} from 'react';
import withStyles from "@material-ui/core/styles/withStyles";
import {
    Divider,
    List,
    ListItem,
    ListItemText, makeStyles
} from "@material-ui/core";
import {Draggable, Droppable} from 'react-beautiful-dnd'
import Card from "@material-ui/core/Card";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../../../../../JsonScreen/Utils/lib";


const styles = () => ({
    cardContentWrapper: {
        height: 120,
        width: 180,
        overflowX: "hidden"
    },
    cardActions: {
        marginTop: 0,
        marginRight: 0,
        display: 'flex'
    },
    cardContentRoot: {
        padding: 0,
        overflowY: "auto"
    },
    list: {
        paddingTop: 0
    },
    subHeader: {
        lineHeight: 1.32
    },
    fieldset: {
        padding: 2,
        boxShadow: 'none',
        border: `1px solid #e5e5e5`,
    },
    listItemDense: {
        paddingTop: 0,
        paddingBottom: 0
    }
});
const useStyles = makeStyles(() => ({
    cardContentWrapper: {
        height: 120,
        width: 180,
        overflowX: "hidden"
    },
    cardActions: {
        marginTop: 0,
        marginRight: 0,
        display: 'flex'
    },
    cardContentRoot: {
        padding: 0,
        overflowY: "auto"
    },
    list: {
        paddingTop: 0
    },
    subHeader: {
        lineHeight: 1.32
    },
    fieldset: {
        padding: 2,
        boxShadow: 'none',
        border: `1px solid #e5e5e5`,
    },
    listItemDense: {
        paddingTop: 0,
        paddingBottom: 0
    }
}));
const RowsColumns = (props) => {
    const {rowsColumns} = props;
    const classes = useStyles();

    return(
        <Card className={classes.fieldset}>
            <legend style={{fontWeight: 'bold'}}>
                Rows
            </legend>
            <Divider/>
            <Droppable droppableId={'rowsColumns'}>
                {(provided) => (
                    <div className={classes.cardContentWrapper}
                         {...provided.droppableProps}
                         ref={provided.innerRef}>
                        <List dense={true}
                              className={classes.list}
                        >
                            <DraggableRowsColumns
                                rowsColumns={rowsColumns}
                            />
                        </List>
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </Card>
    )
}
const DraggableRowsColumns = ({rowsColumns = []}) => {
    const classes = useStyles();
    const {userLanguage} = useSelector(state => state.app);
    return(
        rowsColumns.map((column, index) => {
            const multiLanguageLabel = multiLanguageValue(column.label, userLanguage)
            return (
                <React.Fragment key={`rows_${column.name}_${index}`}>
                    <Draggable
                        draggableId={`${column.name}_rows`}
                        index={index}>
                        {(provided, snapshot) => (
                            <>
                                <ListItem
                                    classes={{dense: classes.listItemDense}}
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    selected={snapshot.isDragging}
                                >
                                    <ListItemText primary={multiLanguageLabel}/>
                                </ListItem>
                                <Divider/>
                            </>
                        )}
                    </Draggable>
                </React.Fragment>
            )
        })
    )
}

export default withStyles(styles)(RowsColumns)